// extracted by mini-css-extract-plugin
export var pathClass = "index-module--pathClass--11gJy";
export var content = "index-module--content--16HFW";
export var grayContent = "index-module--grayContent--1sP4g";